import { graphql } from 'gatsby';
import get from 'lodash/get';
import React from 'react';

import { MarketingCommunicationForms } from '../MarketingCommunicationForms';
import Spacer from '../Spacer';
import { inner, root } from './RichTextNewsletterSignupForm.module.scss';

const RichTextNewsletterSignupForm: React.FC<{
  node: { data: { target: Queries.RichTextNewsletterSignupFormFragment } };
}> = ({ node }) => {
  const entry = get(node, 'data.target');

  if (!entry) {
    console.warn('[RichTextNewsletterSignupForm] Entry not rendered', { node });
    return null;
  }

  return (
    <div className={root}>
      <Spacer />

      <div className={inner}>
        <MarketingCommunicationForms
          form={
            (entry.formType as 'both' | 'newsletter' | 'sms') || 'newsletter'
          }
          tags={(entry.tags as string[]) || []}
          newsletterTitle={entry.title}
          newsletterContent={entry.subtitle?.childMarkdownRemark?.html}
          smsTitle={entry.smsTitle}
          smsContent={entry.smsSubtitle?.childMarkdownRemark?.html}
          location="Editorial"
        />
      </div>

      <Spacer />
    </div>
  );
};

export default RichTextNewsletterSignupForm;

export const query = graphql`
  fragment RichTextNewsletterSignupForm on ContentfulComponentMarketingSignupForm {
    __typename
    contentful_id
    tags
    formType
    title
    subtitle {
      childMarkdownRemark {
        html
      }
    }
    smsTitle
    smsSubtitle {
      childMarkdownRemark {
        html
      }
    }
  }
`;
